var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAf2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z",
    stroke: "#613ED2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14",
    stroke: "#613ED2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19L17 21L21 17",
    stroke: "#613ED2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0277457
    },
    d: "M 11.375723,11.748136 C 10.868854,11.678898 10.269509,11.487442 9.8117302,11.24853 8.8894271,10.767186 8.1977461,10.066511 7.7324352,9.1421965 7.3708353,8.4238982 7.2261481,7.8052953 7.2262521,6.9780347 7.2264311,5.5545672 7.8452088,4.2458146 8.9618497,3.3071398 9.5516458,2.8113432 10.38202,2.430279 11.190445,2.284423 c 0.45743,-0.082529 1.164427,-0.082008 1.626129,0.0012 2.295519,0.413697 3.956884,2.3837405 3.957174,4.6924117 7.9e-5,0.6322141 -0.06654,1.0355428 -0.26579,1.6092485 -0.546906,1.5746908 -1.901799,2.7513808 -3.578478,3.1078168 -0.319684,0.06796 -1.219625,0.09868 -1.553757,0.05304 z M 12.598504,10.15318 C 13.61739,9.9720333 14.529568,9.2433225 14.945712,8.2780681 15.591124,6.7810197 15.018836,5.0387928 13.613041,4.2209959 13.105505,3.9257456 12.630157,3.8023849 12,3.8023849 c -0.247102,0 -0.500879,0.01525 -0.596532,0.035847 -0.363035,0.078173 -0.760089,0.2278336 -1.026589,0.3869509 -1.5916884,0.9503353 -2.0655772,2.9866243 -1.05728,4.5431056 0.2094418,0.3233099 0.6454502,0.7526272 0.965305,0.9504912 0.698407,0.4320384 1.490435,0.5807494 2.3136,0.4344004 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0277457
    },
    d: "m 5.8036253,21.755811 c -0.2785899,-0.07767 -0.5115516,-0.322658 -0.5711715,-0.600656 -0.037624,-0.175434 -0.039503,-2.012827 -0.00254,-2.488021 0.049089,-0.631155 0.1916868,-1.167579 0.457788,-1.7221 0.6678714,-1.391759 1.8912425,-2.335768 3.4313647,-2.647798 0.3136001,-0.06353 0.3210528,-0.06371 2.7144635,-0.06371 h 2.4 l 0.110983,0.06008 c 0.454074,0.245797 0.567473,0.802081 0.248702,1.220012 -0.03717,0.04873 -0.144663,0.127121 -0.238874,0.174199 l -0.171293,0.0856 -2.041811,4.4e-4 c -2.125071,4.57e-4 -2.5478922,0.01661 -2.9196561,0.111528 -1.0613921,0.270997 -1.9186755,1.054351 -2.2570777,2.062434 -0.1577325,0.469877 -0.1618888,0.515106 -0.1788079,1.94583 -0.01551,1.311585 -0.016693,1.333557 -0.077944,1.448149 -0.1793216,0.335483 -0.5602095,0.509902 -0.904122,0.41402 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0277457
    },
    d: "m 16.799874,21.758087 c -0.06874,-0.01929 -0.181111,-0.07418 -0.249711,-0.121984 -0.21401,-0.149129 -2.177935,-2.1435 -2.247839,-2.282686 -0.03521,-0.0701 -0.06825,-0.198144 -0.07598,-0.294462 -0.04431,-0.552008 0.467169,-0.959512 1.008104,-0.803175 0.159995,0.04624 0.185751,0.06877 0.962472,0.842002 l 0.798078,0.794491 1.768396,-1.765389 c 1.209699,-1.207643 1.807842,-1.785818 1.893251,-1.83005 0.175879,-0.09108 0.516588,-0.09234 0.685969,-0.0025 0.275132,0.145888 0.435672,0.404299 0.43467,0.699661 -0.0012,0.348603 0.08814,0.2457 -2.210761,2.546845 -1.649174,1.650783 -2.115847,2.102913 -2.225485,2.156133 -0.172583,0.08377 -0.377843,0.106964 -0.541166,0.06114 z",
    id: "path6"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf2);
export default __webpack_public_path__ + "static/media/AF2.6ab638e69f2f3a505513b7e167b54d53.svg";
export { ForwardRef as ReactComponent };